<template>
  <div>
    <HeaderView />
    <div class="image-container mb-5">
      <img
        src="../../public/staticImages/banner(contact).png"
        class="img-fluid h-50"
        alt="Contact Image"
        style="filter: brightness(50%)"
      />
      <div
        class="text-center text-white position-absolute top-50 start-50 translate-middle"
      >
        <h1>Facilities</h1>
        <p>Home > Facilities</p>
      </div>
    </div>

    <div class="container" v-for="(data, index) in facilities" :key="index">
      <div
        class="row mb-5 d-flex align-items-center animate__animated animate__bounceInRight animate__duration-5s"
        v-if="index % 2 == 0"
      >
        <div class="col-md-6">
          <img :src="data.image" class="img-fluid" alt="Image" />
        </div>
        <div class="col-md-6">
          <h2 class="text-info text-center my-3 fw-bolder">{{ data.title }}</h2>
          <div class="card rounded-0">
            <div class="card-body m-3">
              <h4
                class="m-1 p-3 text-secondary"
                style="border: 2px solid #a020f0"
              >
                {{ data.description }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row mb-5 d-flex align-items-center animate__animated animate__bounceInLeft animate__duration-5s"
        v-else
      >
        <div class="col-md-6">
          <img :src="data.image" class="img-fluid" alt="Image" />
        </div>
        <div class="col-md-6">
          <h2 class="text-info text-center my-3 fw-bolder">{{ data.title }}</h2>
          <div class="card rounded-0">
            <div class="card-body m-3">
              <h4
                class="m-1 p-3 text-secondary"
                style="border: 2px solid #a020f0"
              >
                {{ data.description }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import axios from "axios";
import HeaderView from "./Layouts/HeaderView.vue";
import FooterView from "./Layouts/FooterView.vue";
export default {
  name: "FacilitiesView",
  components: { HeaderView, FooterView },
  data() {
    return {
      BaseUrl: process.env.VUE_APP_BASE_URL,
      facilities: {},
    };
  },
  methods: {
    // async getFacilities() {
    //   await axios.get(`${this.BaseUrl}/facilities`).then((response) => {
    //     console.log(response.data.data);
    //     this.facilities = response.data.data;
    // console.log(response.data.data[1].image);
    // console.log(response.data.data);
    // for(let i = 0; i < response.data.data.length; i++){
    //     response.data.data[i].image = process.env.VUE_APP_BASE_URL + "/facilities/"+response.data.data[i].image;
    // }
    // console.log(this.facilities);
    // });
    // },

    async getFacilities() {
      try {
        const response = await axios.get(`${this.BaseUrl}/facilities`);
        this.facilities = response.data.data;
        console.log(this.facilities);
      } catch (error) {
        console.error("Error fetching facilities:", error);
      }
    },
  },
  mounted() {
    this.getFacilities();
    document.title = "Facilities - Mandalay Water Boom";
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}

.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-img-top {
  max-height: 200px;
  object-fit: cover;
}
</style>
